import { useTranslation } from 'react-i18next'

// Use throughout the app instead of plain `useTranslation`
export const useAppTranslation = useTranslation
